const AUTH_TOKEN_KEY = 'magtuner_auth_token';
const API_BASE_URL = 'https://api.magtuner.com';
const ADMIN_API_BASE_URL = 'https://api.magtuner.com/admin';

export const authProvider = {
  login: async () => {
    // Redirect to OAuth login
    const redirectUrl = encodeURIComponent(window.location.origin);
    const loginUrl = `${API_BASE_URL}/magtuner/users/auth/magtuner?magtuner_redirect_url=${redirectUrl}`;
    window.location.href = loginUrl;
  },

  logout: () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_TOKEN_KEY);

    if (token) {
      // Redirect to logout URL with token
      const logoutUrl = `${API_BASE_URL}/api/v1/users/sign_out?token=${token}`;
      window.location.href = logoutUrl;
    }

    return Promise.resolve();
  },

  checkAuth: async () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);

    if (!token) {
      return Promise.reject();
    }

    // Check if token is valid by verifying with admin endpoint
    try {
      const response = await fetch(`${API_BASE_URL}/admin/users/admin`, {
        headers: {
          'Authorization': `Token token="${token}"`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        return Promise.resolve();
      } else {
        localStorage.removeItem(AUTH_TOKEN_KEY);
        return Promise.reject();
      }
    } catch (error) {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      return Promise.reject(error);
    }
  },

  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getPermissions: () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    return token ? Promise.resolve('admin') : Promise.reject();
  },

  getIdentity: async () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);

    if (!token) {
      return Promise.reject();
    }

    try {
      const response = await fetch(`${API_BASE_URL}/admin/users/admin`, {
        headers: {
          'Authorization': `Token token="${token}"`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        return {
          id: data.user.id,
          fullName: `${data.user.first_name} ${data.user.last_name}`,
          avatar: null,
        };
      }
    } catch (error) {
      console.error('Failed to get user identity:', error);
    }

    return Promise.reject();
  },
};

// Function to handle OAuth callback and extract token from URL
export const handleAuthCallback = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    // Remove token from URL
    const url = new URL(window.location);
    url.searchParams.delete('token');
    window.history.replaceState({}, document.title, url.pathname + url.hash);
    return true;
  }

  return false;
};

// Function to get stored token
export const getAuthToken = () => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};
